import { useEffect, useState } from "react";
import { api } from "../lib/api";
import GoogleEventsMap from "../components/GoogleEventsMap";
import { toast } from "sonner";

export default function MapPage() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    api.get("/events?limit=500").then(({ data }) => setEvents(data.events)).catch(() => toast.error("Errore mappa"));
  }, []);
  return (
    <div className="max-w-[1600px] mx-auto px-6 lg:px-12 py-12">
      <div className="mb-8">
        <div className="text-xs font-bold uppercase tracking-[0.3em] text-primary mb-3">Explore</div>
        <h1 className="font-display text-4xl sm:text-6xl font-black uppercase tracking-tighter" data-testid="map-title">Mappa eventi</h1>
        <p className="text-neutral-400 mt-3 text-sm">{events.length} eventi in Europa. Clicca un pin per i dettagli.</p>
      </div>
      <GoogleEventsMap events={events} height="75vh" />
    </div>
  );
}
